import { TableCell, TableRow } from "@mui/material";

import { AssociationRecord } from "@/shared/domain/association";
import { MessagePathRecord, TopicRecord } from "@/shared/domain/topics";

import { MessagePathLink } from "../links";
import { RobotoTypography } from "../RobotoTypography";

import { Cell } from "./Cell";
import styles from "./Cell.module.css";

function extractFieldFromMetadata<T>(
  key: string,
  metadata: Record<string, unknown>,
) {
  if (!(key in metadata)) {
    return "-";
  } else {
    return metadata[key] as T;
  }
}

interface MessagePathRowProps {
  messagePath: MessagePathRecord;
  topicRecord: TopicRecord;
  topicAssociation: AssociationRecord;
}

export function MessagePathRow({
  messagePath,
  topicAssociation,
  topicRecord,
}: MessagePathRowProps) {
  return (
    <TableRow key={messagePath.message_path_id}>
      <TableCell
        sx={{
          paddingLeft: 0,
        }}
      >
        <RobotoTypography variant="body2">
          <MessagePathLink
            messagePath={messagePath}
            topicAssociation={topicAssociation}
            topic={topicRecord}
            className={styles.body}
          />
        </RobotoTypography>
      </TableCell>
      <Cell className={styles.body}>{messagePath.data_type}</Cell>
      <Cell className={styles.body}>
        {extractFieldFromMetadata("min", messagePath.metadata)}
      </Cell>
      <Cell className={styles.body}>
        {extractFieldFromMetadata("max", messagePath.metadata)}
      </Cell>
      <Cell className={styles.body}>
        {extractFieldFromMetadata("mean", messagePath.metadata)}
      </Cell>
      <Cell className={styles.body}>
        {extractFieldFromMetadata("median", messagePath.metadata)}
      </Cell>
      <Cell className={styles.body}>
        {extractFieldFromMetadata("true_count", messagePath.metadata)}
      </Cell>
      <Cell className={styles.body}>
        {extractFieldFromMetadata("false_count", messagePath.metadata)}
      </Cell>
    </TableRow>
  );
}
